import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DateRangeFilter = ({ startDate, endDate, onDateChange, preset, onPresetChange }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const presetOptions = [
    { value: 'custom', label: 'Personalizado' },
    { value: 'today', label: 'Hoy' },
    { value: 'yesterday', label: 'Ayer' },
    { value: 'last7days', label: 'Últimos 7 días' },
    { value: 'last30days', label: 'Últimos 30 días' },
    { value: 'thisMonth', label: 'Este mes' },
    { value: 'lastMonth', label: 'Mes anterior' },
    { value: 'thisQuarter', label: 'Este trimestre' },
    { value: 'thisYear', label: 'Este año' }
  ];

  const handlePresetChange = (e) => {
    const selectedPreset = e?.target?.value;
    onPresetChange(selectedPreset);

    const today = new Date();
    let newStartDate, newEndDate;

    switch (selectedPreset) {
      case 'today':
        newStartDate = today?.toISOString()?.split('T')?.[0];
        newEndDate = today?.toISOString()?.split('T')?.[0];
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday?.setDate(yesterday?.getDate() - 1);
        newStartDate = yesterday?.toISOString()?.split('T')?.[0];
        newEndDate = yesterday?.toISOString()?.split('T')?.[0];
        break;
      case 'last7days':
        const last7 = new Date(today);
        last7?.setDate(last7?.getDate() - 7);
        newStartDate = last7?.toISOString()?.split('T')?.[0];
        newEndDate = today?.toISOString()?.split('T')?.[0];
        break;
      case 'last30days':
        const last30 = new Date(today);
        last30?.setDate(last30?.getDate() - 30);
        newStartDate = last30?.toISOString()?.split('T')?.[0];
        newEndDate = today?.toISOString()?.split('T')?.[0];
        break;
      case 'thisMonth':
        newStartDate = new Date(today?.getFullYear(), today?.getMonth(), 1)?.toISOString()?.split('T')?.[0];
        newEndDate = today?.toISOString()?.split('T')?.[0];
        break;
      case 'lastMonth':
        const lastMonthStart = new Date(today?.getFullYear(), today?.getMonth() - 1, 1);
        const lastMonthEnd = new Date(today?.getFullYear(), today?.getMonth(), 0);
        newStartDate = lastMonthStart?.toISOString()?.split('T')?.[0];
        newEndDate = lastMonthEnd?.toISOString()?.split('T')?.[0];
        break;
      case 'thisQuarter':
        const quarterStart = new Date(today?.getFullYear(), Math.floor(today?.getMonth() / 3) * 3, 1);
        newStartDate = quarterStart?.toISOString()?.split('T')?.[0];
        newEndDate = today?.toISOString()?.split('T')?.[0];
        break;
      case 'thisYear':
        newStartDate = new Date(today?.getFullYear(), 0, 1)?.toISOString()?.split('T')?.[0];
        newEndDate = today?.toISOString()?.split('T')?.[0];
        break;
      default:
        return;
    }

    if (newStartDate && newEndDate) {
      onDateChange({ startDate: newStartDate, endDate: newEndDate });
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-4">
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-smooth"
        >
          <Icon 
            name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
            size={20} 
          />
          Filtros de Fecha
        </button>
      </div>

      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Período Predefinido
            </label>
            <Select
              value={preset}
              onChange={handlePresetChange}
              options={presetOptions}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Fecha Inicio
            </label>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => {
                onPresetChange('custom');
                onDateChange({ startDate: e?.target?.value, endDate });
              }}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Fecha Fin
            </label>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => {
                onPresetChange('custom');
                onDateChange({ startDate, endDate: e?.target?.value });
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;